import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=7491d9a0&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=7491d9a0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7491d9a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7491d9a0')) {
      api.createRecord('7491d9a0', component.options)
    } else {
      api.reload('7491d9a0', component.options)
    }
    module.hot.accept("./Attachment.vue?vue&type=template&id=7491d9a0&scoped=true", function () {
      api.rerender('7491d9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/po/Attachment.vue"
export default component.exports